// MAGAZINE kit — engagement-status → sticker config. Maps each engagement
// status to a poppy fill + the right text colour for legibility, and the
// media-aware label. Returns { text, color, textColor } for magFeatureHero's
// `sticker` / magKicker. Mirrors the gallery tile sticker colours.
import { statusLabel } from "../status-badge.js";
import { MAG } from "../../utils/magazine.js";

const TINT = {
	playing: { color: MAG.lime, textColor: "#0b0b0f" },
	replaying: { color: MAG.yellow, textColor: "#0b0b0f" },
	done: { color: "#ffffff", textColor: "#0b0b0f" },
	poked: { color: "#19d3e8", textColor: "#06222a" },
	on_pause: { color: "#ff7a1a", textColor: "#0b0b0f" },
	bounced: { color: "rgba(255,255,255,.18)", textColor: "#ffffff" },
	not_interested: { color: "rgba(255,255,255,.14)", textColor: "#9a9aa2" },
	want_to_check: { color: "rgba(255,255,255,.18)", textColor: "#ffffff" },
	haven_started: { color: "rgba(255,255,255,.18)", textColor: "#ffffff" },
};
const DEFAULT = { color: "rgba(255,255,255,.18)", textColor: "#ffffff" };

export function statusSticker(status, mediaType) {
	if (!status) return null;
	const tint = TINT[status] ?? DEFAULT;
	return { text: statusLabel(status, mediaType), color: tint.color, textColor: tint.textColor };
}
